import gql from 'graphql-tag'

export const fetchCountriesSelect = () => {
	// TODO: add where: {active: {_eq: true}}, and active column in database
	return {
		query: gql`
			{
				countries: countries(order_by: { name: asc }) {
					id
					name
					code
				}
			}
		`
	}
}
